<template>
  <div>
    <Head />
    <div class="layout">
      <div class="hwtool">
        <div class="part-1">
          <div class="main">
            <div class="left">
              <p class="title">
                <span>{{$t('hwtool.part1.tit1')}}</span>
                 <span>{{$t('hwtool.part1.hwtool')}}</span>  
              </p>
              <p class="title2">{{$t('hwtool.part1.tit2')}}</p>
              <div class="down">
                <div class="icon">
                  <a class="ios"  href="https://testflight.apple.com/join/P3hprKuv">
                    <i  :class="lang == 'en'? 'iconfont iconios-2 i1en' :'iconfont iconios-2 i1cn'"  ></i>
                    <span>iOS{{$t('hwtool.part1.down')}}</span>
                  </a>
                  <a class="and"  href="https://toolserver.hwelltech.com/download/hwtool-last.apk">
                    <i  :class="lang == 'en'? 'iconfont iconandroid i2en' :'iconfont iconandroid i2cn'" ></i>
                    <span>Android{{$t('hwtool.part1.down')}}</span>
                  </a>
                </div>
                <div class="img">
                  <div class="top">
                    <img :class="lang == 'cn' ?'imgcn':'imgen'" src="../../assets/images/pc/hwtool/ewm.png" alt />
                   
                  </div>
                  <p class="text">{{$t('hwtool.part1.ewm')}}</p>
                </div>
              </div>
            </div>
            <div class="right">
              <img src="../../assets/images/pc/hwtool/part1-2.png" alt />
            </div>
          </div>
        </div>
        <div class="part-2">
          <div class="main">
            <p class="title">{{$t('hwtool.part2.tit')}}</p>
            <div class="center">
              <div class="d">
                <img src="../../assets/images/pc/hwtool/part2-1.png" alt />
                <p>{{$t('hwtool.part2.title1')}}</p>
                <p>{{$t('hwtool.part2.text1')}}</p>
              </div>
              <div class="d">
                <img src="../../assets/images/pc/hwtool/part2-2.png"  alt />
                <p>{{$t('hwtool.part2.title2')}}</p>
                <p>{{$t('hwtool.part2.text2')}}</p>
              </div>
              <div class="d">
                <img src="../../assets/images/pc/hwtool/part2-3.png"  alt />
                <p>{{$t('hwtool.part2.title3')}}</p>
                <p>{{$t('hwtool.part2.text3')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "../../components/pc/Head";
import Foot from "../../components/pc/Foot";

export default {
  name: "hwtool",
  components: {
    Head,
    Foot
  },
  data() {
    return {
      value2: 0,

      cn: false,
      en: false,
      
    };
  }, 
  mounted() {
    this.mobile();
  },

  created() {
    this.getLang();
  },
  methods: {
    getLang() {
      var lang;
      if (this.$i18n.locale == "en") {
        this.en = true;
        this.lang = "en";
      } else {
        this.cn = true;
        this.lang = "cn";
      }
    },
     mobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if((flag && flag.length) >0){
          this.$router.replace('/mobile'+this.$route.path)
        }
    },
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/var.less");
.layout {
  min-height: calc(100vh);
  // max-width:@max-width;
  min-width: @min-width;
  background-color: #f8f9fb;
}
.hwtool {
  .part-1 {
    height: 697px;
    background-image: url("../../assets/images/pc/hwtool/bg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .main {
      .left {
        width: 61%;
        float: left;
        .title {
          margin-top: 211px;
          font-size: 49px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          span:nth-child(1) {
            display: inline-block;
            margin-right: 20px;
          }
        }
        .title2 {
          margin-top: 28px;
          font-size: 24px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
        }
        .down {
          display: flex;
          margin-top: 80px;
          .icon {
            flex: 1;
            .ios {
              width: 202px;
              height: 52px;
              background: rgba(255, 255, 255, 0.2);
              position: relative;
              border-radius: 26px;
              // cursor: not-allowed;
               display: inline-block;
              
              i {
                font-size: 38px;
                color: #fff;
                z-index: 99;
                margin: 0 17px 0 20px;
                line-height: 50px;
              }
              .i1cn{

              }
              .i1en{
                margin: 0 17px 0 40px;
              }
              
              span {
                display: inline-block;
                position: absolute;
                top: 14px;
                font-size: 18px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
              }
            }

            .and {
                cursor: pointer;
              margin-top: 25px;
              width: 202px;
              height: 52px;
              background: rgba(255, 255, 255, 0.2);
              position: relative;
              border-radius: 26px;
              display: inline-block;
              i {
                font-size: 38px;
                color: #fff;
                z-index: 99;
                margin: 0 17px 0 20px;
                line-height: 50px;
              }
              .i2cn{

              }
              .i2en{
                margin: 0 17px 0 40px;
              }
              span {
                display: inline-block;
                position: absolute;
                top: 14px;
                font-size: 18px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
              }
            }
          }
          .img {
            flex: 2;
            padding-left: 60px;
            .top {
              padding-left: 5px;
              img {
                width: 104px;
                height: 104px;
              }
              .imgcn{
                 margin-left: 1px;
              }
              .imgen{
                margin-left: 28px;
              }
            }
            .text {
              font-size: 16px;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }
          }
        }
      }
      .right {
        width: 38%;
        float: left;
        img {
          margin-top: 271px;
          width: 429px;
        }
      }
    }
  }
  .part-2 {
    height: 645px;
    background: rgba(255, 255, 255, 1);
    padding-top: 80px;
    .main {
      .title {
        font-size: 40px;
        text-align: center;
        font-weight: 400;
        color: rgba(49, 65, 133, 1);
      }
      .center {
        margin-top: 60px;
        text-align: center;
        display: flex;
        .d {
          flex: 1;
          width: 330px;
          height: 342px;
          margin: 0 35px;
          background:rgba(255,255,255,1);
          box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.1);
          padding:42px 40px 0  40px;
          &:hover{
            box-shadow:0px 0px 10px 0px rgba(0, 0, 0, 0.2);
          }
          img {
            margin: 0 auto;
            height: 85px;
            
          }

          p:nth-child(2) {
            margin-top: 35px;
            font-size: 24px;
            font-weight: 400;
            color: rgba(49, 65, 133, 1);
          }
          p:nth-child(3) {
            margin-top: 20px;
            font-size: 18px;
            font-weight: 400;
            color: rgba(131, 146, 176, 1);
          }
        }
      }
    }
  }
}
</style>
